import { inject } from '@angular/core';
import { Router, CanMatchFn } from '@angular/router';

import { SessionService } from '@/app/core/services/session';

export const guestGuard: CanMatchFn = () => {
  const router = inject(Router);
  const sessionsService = inject(SessionService);

  if (sessionsService.getToken()) {
    router.navigate(['/']);
    return false;
  }

  return true;
};
